import { render, staticRenderFns } from "./PageNotFoundComponent.vue?vue&type=template&id=0084c6a2&scoped=true"
import script from "./PageNotFoundComponent.js?vue&type=script&lang=js&external"
export * from "./PageNotFoundComponent.js?vue&type=script&lang=js&external"
import style0 from "./PageNotFoundComponent.scss?vue&type=style&index=0&id=0084c6a2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0084c6a2",
  null
  
)

export default component.exports